import { clsx } from 'clsx';

const ON_TONES = {
  default: 'bg-gat-green text-white',
  win: 'bg-status-won text-white',
  open: 'bg-status-open text-white',
  lost: 'bg-status-lost text-white',
  cancel: 'bg-status-cancel text-white',
};

export function Chip({ on = false, tone = 'default', removable = false, onClick, onRemove, className, children }) {
  return (
    <span
      onClick={onClick}
      className={clsx(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11.5px] font-semibold cursor-pointer transition-colors',
        on ? ON_TONES[tone] : 'bg-surface-3 text-text-body hover:bg-[#EAE7E0]',
        className
      )}
    >
      {children}
      {removable && on && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.();
          }}
          className="text-[13px] leading-none opacity-80 hover:opacity-100"
          aria-label="Remove"
        >
          ×
        </button>
      )}
    </span>
  );
}
